
export const hasUserCompletedSpecialization = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("SignupData"));
    const specializationCompleted = localStorage.getItem("specializationCompleted");
    
    const hasSubcategory = !!(userData?.data?.subcategory);
    const isMarkedCompleted = specializationCompleted === "true";
    
    return hasSubcategory || isMarkedCompleted;
  } catch (error) {
    console.error("Error checking specialization status:", error);
    return false;
  }
};

export const getUserSpecializations = () => {
  try {
    const specializations = localStorage.getItem("userSpecializations");
    return specializations ? JSON.parse(specializations) : [];
  } catch (error) {
    console.error("Error getting user specializations:", error);
    return [];
  }
};

export const markSpecializationCompleted = (specializations, subcategory) => {
  try {
    
    // Update SignupData with subcategory
    const storedData = localStorage.getItem("SignupData");
    const localData = storedData ? JSON.parse(storedData) : { data: {} };
    
    if (!localData.data) {
      localData.data = {};
    }
    
    localData.data.subcategory = subcategory;
    localStorage.setItem("SignupData", JSON.stringify(localData));    
    // Mark as completed
    localStorage.setItem("specializationCompleted", "true");
    localStorage.setItem("userSpecializations", JSON.stringify(specializations));
    
    // Get the return path
    const returnPath = localStorage.getItem("returnAfterSpecialization");
    // Return the path to redirect to (default to /feed if no return path)
    return returnPath && returnPath !== "/specialization" ? returnPath : "/feed";
  } catch (error) {
    console.error("Error marking specialization as completed:", error);
    return "/feed"; // Fallback to feed page
  }
};
export const clearSpecializationData = () => {
  try {
    localStorage.removeItem("specializationCompleted");
    localStorage.removeItem("userSpecializations");
    localStorage.removeItem("returnAfterSpecialization");
    
    // Also remove from SignupData
    const storedData = localStorage.getItem("SignupData");
    if (storedData) {
      const localData = JSON.parse(storedData);
      if (localData.data) {
        delete localData.data.subcategory;
        localStorage.setItem("SignupData", JSON.stringify(localData));
      }
    }    
  } catch (error) {
    console.error("Error clearing specialization data:", error);
  }
};
export const isNewUser = () => {
  try {
    const userData = JSON.parse(localStorage.getItem("SignupData"));
    const hasToken = !!(userData?.data?.id);
    const hasCompletedSpecialization = hasUserCompletedSpecialization();
        
    // User is considered new if they have a token but haven't completed specialization
    return hasToken && !hasCompletedSpecialization;
  } catch (error) {
    console.error("Error checking if user is new:", error);
    return false;
  }
};

export const handleUserLogout = () => {
  try {
    localStorage.removeItem("SignupData");
    localStorage.removeItem("specializationCompleted");
    localStorage.removeItem("userSpecializations");
    localStorage.removeItem("returnAfterSpecialization");
    // Add any other cleanup needed    
  } catch (error) {
    console.error("Error during logout:", error);
  }
};

export const getUserData = () => {
  try {
    const userData = localStorage.getItem("SignupData");
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
};

export const isUserAuthenticated = () => {
  try {
    const userData = getUserData();
    const isAuth = !!(userData?.data?.id);
    return isAuth;
  } catch (error) {
    console.error("Error checking authentication:", error);
    return false;
  }
};

export const getUserSubcategory = () => {
  try {
    const userData = getUserData();
    return userData?.data?.subcategory || "";
  } catch (error) {
    console.error("Error getting user subcategory:", error);
    return "";
  }
};

export const setReturnPath = (path) => {
  if (path && path !== "/specialization") {
    localStorage.setItem("returnAfterSpecialization", path);
  } else {
  }
};

export const getReturnPath = () => {
  const path = localStorage.getItem("returnAfterSpecialization");
  return path;
};

export const isValidReturnPath = (path) => {
  if (!path || typeof path !== 'string') return false;
  
  const invalidPaths = [
    '/login',
    '/signup', 
    '/register',
    '/auth',
    '/specialization'
  ];
  
  return !invalidPaths.some(invalidPath => 
    path.toLowerCase().includes(invalidPath.toLowerCase())
  );
};

export const getSafeReturnPath = () => {
  const storedPath = getReturnPath();
  
  if (isValidReturnPath(storedPath)) {
    return storedPath;
  }
  
 
  return "/feed";
};